import styled from 'styled-components';

import { toDvhWithVhFallback } from '../../utils/viewportHeightUtils';

export const BottomSheetContainer = styled.div<{
  $maxHeight?: string;
  $height?: string;
  $keyboardInset?: number;
  $constrainToVisualViewport?: boolean;
}>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: ${toDvhWithVhFallback(30)};
  max-height: ${(props) => props.$maxHeight || toDvhWithVhFallback(80)};
  height: ${(props) => props.$height || 'auto'};
  padding-bottom: ${(props) =>
    props.$constrainToVisualViewport ? 0 : props.$keyboardInset || 0}px;
  overscroll-behavior: contain;
  touch-action: pan-y;
`;

export const BottomSheetContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
`;

export const BottomSheetBackdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.56);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  transition: opacity 300ms;
`;

export const BottomSheetFooter = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;
`;
